/**
 * CTRNE delivery bar — live cutoff countdown with working-day, holiday and
 * timezone awareness. Initialises every [data-ctrne-deliv] on the page.
 */
(function () {
  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // 1st, 2nd, 3rd, 4th … 11th/12th/13th are the exceptions, hence the %100.
  function ordinal(n) {
    var suffix = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (suffix[(v - 20) % 10] || suffix[v] || suffix[0]);
  }

  function longDate(d) {
    return ordinal(d.getDate()) + ' ' + MONTHS[d.getMonth()];
  }

  function initBar(root) {
    if (root.dataset.ctrneInit === 'true') return;
    root.dataset.ctrneInit = 'true';

    var cutoffH = parseInt(root.getAttribute('data-cutoff-hour'), 10);
    var cutoffM = parseInt(root.getAttribute('data-cutoff-minute'), 10);
    if (isNaN(cutoffH)) cutoffH = 16;
    if (isNaN(cutoffM)) cutoffM = 0;

    var work = (root.getAttribute('data-dispatch-days') || '1,2,3,4,5')
      .split(',').map(function (n) { return parseInt(n, 10); })
      .filter(function (n) { return !isNaN(n); });
    var workSet = {};
    work.forEach(function (n) { workSet[n] = true; });

    var holidays = {};
    (root.getAttribute('data-holidays') || '').split(',').forEach(function (d) {
      d = d.trim(); if (d) holidays[d] = true;
    });

    var pre = root.getAttribute('data-pre') || '';
    var mid = root.getAttribute('data-mid') || '';
    var after = root.getAttribute('data-after') || '';
    var tomorrowWord = root.getAttribute('data-tomorrow') || 'tomorrow,';
    var hideWhenClosed = root.getAttribute('data-hide-when-closed') === 'true';
    var tz = root.getAttribute('data-tz') || '';
    // Asset JS cannot use the `t` filter, so the block passes the
    // merchant-editable labels in as data attributes.
    var lblHrs = root.getAttribute('data-hrs') || 'Hrs';
    var lblMins = root.getAttribute('data-mins') || 'Mins';
    var lblSecs = root.getAttribute('data-secs') || 'Secs';

    function storeNow() {
      if (!tz) return new Date();
      try { return new Date(new Date().toLocaleString('en-US', { timeZone: tz })); }
      catch (e) { return new Date(); }
    }
    function iso(d) {
      return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
    }
    function isWorking(d) {
      return workSet[d.getDay()] === true && !holidays[iso(d)];
    }
    function nextWorkingDay(from) {
      var d = new Date(from.getTime());
      d.setDate(d.getDate() + 1);
      var guard = 0;
      while (!isWorking(d) && guard < 400) { d.setDate(d.getDate() + 1); guard++; }
      return d;
    }

    var textEl = root.querySelector('[data-ctrne-deliv-text]');
    if (!textEl) return;

    function render() {
      var now = storeNow();
      var cutoff = new Date(now.getTime());
      cutoff.setHours(cutoffH, cutoffM, 0, 0);

      var openToday = isWorking(now) && now < cutoff;
      var dispatchDate = openToday ? now : nextWorkingDay(now);
      var deliveryDate = nextWorkingDay(dispatchDate);

      var tmr = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
      var isTomorrow = iso(deliveryDate) === iso(tmr);
      // "TOMORROW" reads better than "tomorrow, Wednesday", and matches the
      // countdown the brand ran previously.
      var dayWord = isTomorrow ? tomorrowWord : DAYS[deliveryDate.getDay()];

      if (!openToday && hideWhenClosed) { root.style.display = 'none'; return; }

      textEl.textContent = '';

      // Past cutoff the clock is gone, so the line has to carry the urgency on
      // its own: name the action and the exact delivery date rather than
      // stating a day passively.
      var leadText = openToday
        ? pre + ' ' + dayWord
        : (after || pre) + ' ' + DAYS[deliveryDate.getDay()] + ' ' + longDate(deliveryDate);

      var lead = document.createElement('span');
      lead.className = 'ctrne-b-deliv__lead';
      lead.textContent = leadText;
      textEl.appendChild(lead);

      if (openToday) {
        var diff = Math.max(0, cutoff - now);
        textEl.appendChild(document.createTextNode(' ' + mid));
        appendUnit(pad(Math.floor(diff / 3600000)), lblHrs);
        appendUnit(pad(Math.floor((diff % 3600000) / 60000)), lblMins);
        appendUnit(pad(Math.floor((diff % 60000) / 1000)), lblSecs);
      }

      root.style.display = '';
    }

    function appendUnit(value, label) {
      var num = document.createElement('span');
      num.className = 'ctrne-b-deliv__num';
      num.textContent = value;
      textEl.appendChild(num);

      var unit = document.createElement('span');
      unit.className = 'ctrne-b-deliv__unit';
      unit.textContent = label;
      textEl.appendChild(unit);
    }

    render();
    setInterval(render, 1000);
  }

  function boot() {
    var bars = document.querySelectorAll('[data-ctrne-deliv]');
    for (var i = 0; i < bars.length; i++) initBar(bars[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init after theme-editor section renders
  document.addEventListener('shopify:section:load', boot);
})();
